module.exports = __webpack_public_path__ + "img/4.50ac72c1.png";